import { Helmet } from "react-helmet";
import { SortOrder } from "@covertree/agent-portal-graphql";
import { TableView } from "@covertree/ui/table/TableView";

import { useGetPendingCancellationPolicies } from "./useGetPendingCancellationPolicies";
import formatPageTitle from "@utils/formatPageTitle";

export default function PendingCancellationPolicies() {
  const {
    loading,
    error,
    policies,
    columns,
    filters,
    sortBy,
    order,
    totalCount,
    rowsPerPage,
    currentPage,
    handleChangePage,
    handleFilterChange,
    handleSortChange,
    handleRowsPerPageChange,
  } = useGetPendingCancellationPolicies();

  return (
    <>
      <Helmet>
        <title>{formatPageTitle("Pending Cancellation")}</title>
      </Helmet>
      <TableView
        header="Pending Cancellation"
        loading={loading}
        error={error}
        tabs={filters}
        totalCount={totalCount}
        page={currentPage}
        rows={policies}
        rowsPerPage={rowsPerPage}
        sortBy={sortBy}
        sortOrder={order === SortOrder.Ascending ? "asc" : "desc"}
        columns={columns}
        onTabChange={handleFilterChange}
        onPageChange={handleChangePage}
        onSortChange={handleSortChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </>
  );
}
